import request from '@/utils/request'
export function getCarList(data) {
  return request({
    url: '/app-api/website/car/list',
    method: 'get',
    data: data
  })
}
